import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DsInputPasswordComponent, DsPasswordState } from './ds-input-password.component';

@Component({
  selector: 'ds-input-password-numeric',
  standalone: true,
  imports: [DsInputPasswordComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ds-input-password
      [label]="label"
      [hasLabelTrailingContent]="hasLabelTrailingContent"
      [placeholder]="placeholder"
      [value]="value"
      [helpText]="helpText"
      [showHelpText]="showHelpText"
      [maxCharacters]="maxCharacters"
      [state]="state"
      [disabled]="disabled"
      [numeric]="true"
      autocomplete="one-time-code"
      [showPasswordLabel]="showPasswordLabel"
      [hidePasswordLabel]="hidePasswordLabel"
      (valueChange)="valueChange.emit($event)"
      (focused)="focused.emit($event)"
      (blurred)="blurred.emit($event)"
    >
      <ng-content select="[labelTrailingContent]"></ng-content>
    </ds-input-password>
  `,
})
export class DsInputPasswordNumericComponent {
  @Input() value: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() helpText: string = '';
  @Input() showHelpText: boolean = false;
  @Input() maxCharacters: number | null = null;
  @Input() state: DsPasswordState = 'default';
  @Input() disabled: boolean = false;
  @Input() hasLabelTrailingContent: boolean = false;
  @Input() showPasswordLabel: string = 'Mostrar contrasena';
  @Input() hidePasswordLabel: string = 'Ocultar contrasena';

  @Output() valueChange = new EventEmitter<string>();
  @Output() focused = new EventEmitter<FocusEvent>();
  @Output() blurred = new EventEmitter<FocusEvent>();
}
